"use strict";
'use es6';

require("graphql/language/printer");

require("@apollo/client");

require("@apollo/client/react/components");